import {
  Button,
  Container,
  Flex,
  Heading,
  StackDivider,
  Text,
  useDisclosure,
  VStack,
} from '@chakra-ui/core';
import { ChevronLeftIcon, ChevronRightIcon } from '@chakra-ui/icons';
import React from 'react';
import LineItem from '../../components/LineItem';
import ResolutionDetailsModal from '../../components/ResolutionDetailsModal';
import { getBTCValue, toBTC } from '../../utils/Utils';

const USDValue = ({ btc }) => (
  <Text as="span" color="#a0a0a0">
    {' '}
    ${getBTCValue(btc)} USD
  </Text>
);

const BetOverviewElections = ({
  prediction,
  betAmount,
  betSize,
  onBack,
  onNext,
  showButtons = true,
}) => {
  const betSizeBTC = toBTC(betSize);
  const betAmountBTC = toBTC(betAmount);
  const betAmountCounterBTC = toBTC(betSize - betAmount);

  const { isOpen, onOpen, onClose } = useDisclosure();

  return (
    <>
      <ResolutionDetailsModal
        isOpen={isOpen}
        onOpen={onOpen}
        onClose={onClose}
      />
      <Container>
        <VStack
          divider={<StackDivider borderColor="gray.400" />}
          spacing={4}
          align="stretch"
        >
          <VStack spacing={4} align="stretch">
            <Heading size="sm" textTransform="uppercase">
              Bet Type
            </Heading>
            <LineItem label="Event">US Election</LineItem>
            <LineItem label="Prediction">
              <Text as="span" textTransform="capitalize">
                {prediction}
              </Text>
            </LineItem>
            <LineItem label="Resolution Date">
              <Text
                fontWeight="500"
                fontSize="sm"
                color="blue.600"
                textDecor="underline"
                onClick={onOpen}
                cursor="pointer"
              >
                View Resolution Details
              </Text>
            </LineItem>
          </VStack>
          <VStack spacing={4} align="stretch">
            <Heading size="sm" textTransform="uppercase">
              Bet Amount &amp; Odds
            </Heading>
            <LineItem label="Total Bet Size">
              {betSizeBTC} BTC
              <USDValue btc={betSizeBTC} />
            </LineItem>
            <LineItem label="Your Deposit">
              {betAmountBTC} BTC <USDValue btc={betAmountBTC} />
            </LineItem>
            <LineItem label="Counterparty Deposit">
              {betAmountCounterBTC} BTC <USDValue btc={betAmountCounterBTC} />
            </LineItem>
            <LineItem
              label="Estimated Potential Profit"
              bg="#edeef0"
              p={2}
              borderRadius="4px"
            >
              {betAmountCounterBTC} BTC
              <USDValue btc={betAmountCounterBTC} />
            </LineItem>
          </VStack>
        </VStack>
      </Container>

      {showButtons && (
        <Flex flexDir="row" mt={8}>
          <Button leftIcon={<ChevronLeftIcon />} onClick={onBack}>
            Go Back
          </Button>
          <Button
            ml="auto"
            colorScheme="blue"
            rightIcon={<ChevronRightIcon />}
            onClick={onNext}
          >
            Confirm
          </Button>
        </Flex>
      )}
    </>
  );
};

const BetOverview = (props) => {
  return <BetOverviewElections {...props} />;
};

export default BetOverview;
